
  const data = [
    "中通快递",
    "韵达快递",
    "圆通速递",
    "百世快递",
    "邮政快递包裹",
    "申通快递",
    "顺丰速运",
    "京东物流",
    "天天快递",
    "EMS",
    "邮政标准快递",
    "宅急送",
    "德邦",
    "德邦快递",
    "中通快运",
    "优速快递",
    "韵达快运",
    "百世快运",
    "安能快运",
    "圆通快运",
    "万象物流",
    "DHL-中国件",
    "苏宁物流",
    "极兔速递",
    "丹鸟",
    "EMS-国际件",
    "YUN TRACK",
    "EWE全球快递",
    "国际包裹",
    "加拿大(CANADA POST)",
    "UPS-全球件",
    "圆通国际",
    "FEDEX-国际件",
    "速尔快递",
    "日日顺物流",
    "同城快寄",
    "跨越速运",
    "USPS",
    "TNT",
    "澳邮中国快运",
    "龙邦速递",
    "DHL-全球件",
    "卓志速运",
    "中邮物流",
    "京广速递",
    "燕文物流",
    "壹米滴答",
    "九曳供应链",
    "邦泰快运",
    "特急送",
    "联合快递",
    "转运四方",
    "中通国际",
    "安得物流",
    "快捷速递",
    "程光快递",
    "联邦快递",
    "澳洲飞跃物流",
    "递四方",
    "联昊通",
    "新顺丰（NSF）",
    "速必达",
    "EMS包裹",
    "美快国际物流",
    "千里速递",
    "宇鑫物流",
    "澳大利亚(AUSTRALIA POST)",
    "芝麻开门",
    "全峰快递",
    "UPS",
    "国通快递",
    "D速快递",
    "斑马物流",
    "富腾达国际货运",
    "优邦速运",
    "长江国际速递",
    "日本（JAPAN POST）",
    "中铁物流",
    "微特派",
    "成都立即送",
    "TRANSRUSH",
    "方舟速递",
    "速达通",
    "中环快递",
    "广东邮政",
    "德国云快递",
    "信丰物流",
    "顺心捷达",
    "天地华宇",
    "SUPERB GRACE",
    "万家物流",
    "EMS-国际件-英文",
    "XLOBO贝海国际",
    "中铁快运",
    "DPD",
    "易达通快递",
    "COE",
    "DHL-德国件（DHL DEUTSCHLAND）",
    "CHS中环国际快递",
    "迅达速递",
    "安达速递",
    "联合速运",
    "新杰物流",
    "加运美",
    "比利时（BPOST）",
    "ONTRAC",
    "中运全速",
    "一速递",
    "疯狂快递",
    "万家康物流",
    "海信物流",
    "极地快递",
    "商桥物流",
    "美通",
    "TNT AUSTRALIA",
    "上海缤纷物流",
    "中国香港(HONGKONG POST)",
    "TNT-全球件",
    "中速快递",
    "安能快递",
    "合众速递(UCS）",
    "苏通快运",
    "中翼国际物流",
    "ARAMEX",
    "盛辉物流",
    "全一快递",
    "泛捷国际速递",
    "安鲜达",
    "恒路物流",
    "中邮速递",
    "AAE-中国件",
    "美国申通",
    "中通（带电话）",
    "黄马甲",
    "光线速递",
    "跨跃国际",
    "百福东方",
    "日日顺智慧物联",
    "转运中国",
    "澳天速运",
    "环球速运",
    "天马迅达",
    "耀飞同城快递",
    "春风物流",
    "CJ物流",
    "EMS-英文",
    "新加坡小包(SINGAPORE POST)",
    "亚风速递",
    "联邦快递-英文",
    "大田物流",
    "UEQ快递",
    "运通中港快递",
    "安迅物流",
    "SQK国际速递",
    "南方传媒物流",
    "盛丰物流",
    "晟邦物流",
    "迅速快递",
    "景顺物流",
    "GLOBALTRACKTRACE",
    "合心速递",
    "新西兰（NEW ZEALAND POST）",
    "TST速运通",
    "皮牙子快递",
    "东方汇",
    "欧亚专线",
    "鸿泰物流",
    "美西快递",
    "明达国际速递",
    "OCS",
    "澳德物流",
    "TOLL",
    "广东速腾物流",
    "速派快递(FASTGO)",
    "西翼物流",
    "全联速运",
    "泛远国际物流",
    "申通国际",
    "龙邦物流",
    "佳怡物流",
    "如风达",
    "锦程快递",
    "速通物流",
    "DPEX",
    "鼎润物流",
    "SYNSHIP快递",
    "德坤物流",
    "宅急便",
    "易客满",
    "亚马逊中国订单",
    "亚洲顺物流",
    "宏递快运",
    "FEDEX-国际件-中文",
    "EFS POST（平安快递）",
    "景光物流",
    "全时速运",
    "韵丰物流",
    "平安达腾飞",
    "远成快运",
    "众川国际",
    "德国(DEUTSCHE POST)",
    "海带宝",
    "DHL BENELUX",
    "魔速达",
    "顺达快递",
    "黑猫宅急便",
    "天翼物流",
    "品骏快递",
    "承诺达",
    "速派快递",
    "飞洋快递",
    "新元国际",
    "CNPEX中邮快递",
    "秦远物流",
    "大洋物流",
    "诚和通",
    "韩国（KOREA POST）",
    "集先锋快递",
    "三真驿道",
    "猛犸速递",
    "百事亨通",
    "荷兰邮政-中文(POSTNL INTERNATIONAL REGISTERED MAIL)",
    "德国优拜物流",
    "出口易",
    "洋包裹",
    "意大利(POSTE ITALIANE)",
    "速递中国",
    "乌克兰邮政包裹",
    "西班牙(CORREOS DE ESPA?A)",
    "久久物流",
    "飞远配送",
    "佳吉快运",
    "加运美速递",
    "安信达",
    "金岸物流",
    "增益速递",
    "科捷物流",
    "货运皇",
    "汇通天下物流",
    "上海航瑞货运",
    "上大物流",
    "优速通达",
    "中远E环球",
    "一号线",
    "泰国138国际物流",
    "港快速递",
    "EMS物流",
    "佐川急便",
    "嘉里大通",
    "蓝天快递",
    "中集冷云",
    "喀麦隆(CAMPOST)",
    "智通物流",
    "荷兰邮政(POSTNL INTERNATIONAL REGISTERED MAIL)",
    "商壹国际物流",
    "能达速递",
    "佳成快递 ",
    "日本郵便",
    "星云速递",
    "ZTE中兴物流",
    "臣邦同城",
    "E通速递",
    "一正达速运",
    "捷安达",
    "飞云快递系统",
    "威盛快递",
    "中澳速递",
    "佳吉快递",
    "法国大包、EMS-法文（CHRONOPOST FRANCE）",
    "瀚朝物流",
    "泰国（THAILAND THAI POST）",
    "考拉速递",
    "远成物流",
    "民航快递",
    "铁中快运",
    "好来运",
    "卡塔尔（QATAR POST）",
    "威时沛运货运",
    "丰通快运",
    "FEDEX-美国件",
    "台湾（中华邮政）",
    "尚橙物流",
    "五六快运",
    "尼尔快递",
    "增速跨境 ",
    "百腾物流",
    "淘布斯国际物流",
    "帮帮发",
    "瑞典（SWEDEN POST）",
    "贝业物流",
    "家家通快递",
    "英国大包、EMS（PARCEL FORCE）",
    "邮邦国际",
    "易优包裹",
    "TRAKPAK",
    "签收快递",
    "ASENDIA USA",
    "聚盟共建",
    "新西兰中通",
    "TCXB国际物流",
    "优优速递",
    "城通物流",
    "玥玛速运",
    "法国小包（COLISSIMO）",
    "LASERSHIP",
    "法国(LA POSTE)",
    "宇佳物流",
    "新加坡EMS、大包(SINGAPORE SPEEDPOST)",
    "安捷物流",
    "皇家云仓",
    "泰国中通ZTO",
    "源安达",
    "EASY EXPRESS",
    "佰麒快递",
    "维普恩物流",
    "荷兰速递(NEDERLAND POST)",
    "星空国际",
    "加州猫速递",
    "肯尼亚(POSTA KENYA)",
    "中国香港环球快运",
    "天翼快递",
    "海中转运",
    "英超物流",
    "美国快递",
    "永昌物流",
    "优海国际速递",
    "龙枫国际快递",
    "GSM",
    "LANDMARK GLOBAL",
    "中粮鲜到家物流",
    "亚欧专线",
    "CITY-LINK",
    "BHT",
    "全速通",
    "皇家物流",
    "瑞士(SWISS POST)",
    "高捷快运",
    "深圳德创物流",
    "LUCFLOW EXPRESS",
    "丰程物流",
    "如家国际快递",
    "奔腾物流",
    "启辰国际速递",
    "易境达国际物流",
    "创一快递",
    "海淘物流",
    "HERMES",
    "传喜物流",
    "易达通",
    "安世通快递",
    "澳世速递",
    "青岛安捷快递",
    "顺捷达",
    "泰国中通CTO",
    "NEWGISTICS",
    "飞豹快递",
    "荷兰邮政-中国件",
    "圣安物流",
    "天天快物流",
    "一号仓",
    "丹麦(POST DENMARK)",
    "赛澳递FOR买卖宝",
    "越南EMS(VNPOST EXPRESS)",
    "新速航",
    "豌豆物流",
    "达发物流",
    "UBI AUSTRALIA",
    "驼峰国际",
    "中国翼",
    "海红网送",
    "秦邦快运",
    "运通速运",
    "百通物流",
    "明通国际快递",
    "河北橙配",
    "云达通",
    "准实快运",
    "一智通",
    "展勤快递",
    "JCEX",
    "中技物流",
    "澳通华人物流",
    "中环转运",
    "共速达",
    "恒宇运通",
    "HIGHSINCE",
    "直德邮",
    "全球快运",
    "彪记快递",
    "陆本速递 LUBEN EXPRESS",
    "马来西亚小包（MALAYSIA POST(REGISTERED)）",
    "越丰物流",
    "百世云配",
    "俄罗斯邮政(RUSSIAN POST)",
    "顺丰-繁体",
    "斯洛文尼亚(SLOVENIA POST)",
    "TNT UK",
    "明辉物流",
    "ABF",
    "E速达",
    "嘉里大荣物流",
    "ADP国际快递",
    "AIRPAK EXPRESSS",
    "爱尔兰(AN POST)",
    "锋鸟物流",
    "成都东骏物流",
    "万庚国际速递",
    "一邦速递",
    "转瞬达集运",
    "泰捷达国际物流",
    "A2U速递",
    "速舟物流",
    "嘉诚速达",
    "USPSCN",
    "运通中港",
    "飛斯特",
    "北京EMS",
    "比利时国际(BPOST INTERNATIONAL)",
    "递四方澳洲",
    "中国澳门(MACAU POST)",
    "明亮物流",
    "林道国际快递",
    "纵通速运",
    "EFSPOST",
    "心怡物流",
    "华瀚快递",
    "西游寄",
    "DHL小包",
    "俄顺达",
    "飞康达",
    "牙买加（JAMAICA POST）",
    "捷邦物流",
    "金大物流",
    "韩国邮政",
    "百千诚物流",
    "中国香港骏辉物流",
    "德尚国际速递",
    "快速递",
    "腾达速递",
    "鹏远国际速递",
    "荷兰包裹(POSTNL INTERNATIONAL PARCELS)",
    "全日通",
    "全速物流",
    "中天万运",
    "澳邦国际物流",
    "欧洲UEX",
    "邦送物流",
    "可可树美中速运",
    "中国香港(HONGKONG POST)英文",
    "中外运速递",
    "AOL澳通速递",
    "蜜蜂速递",
    "7号速递",
    "凡宇快递",
    "加拿大联通快运",
    "莱索托(LESOTHO POST)",
    "蓝天国际快递",
    "联运通物流",
    "振捷国际货运",
    "巴巴多斯(BARBADOS POST)",
    "加拿大邮政",
    "吉祥邮（澳洲）",
    "三态速递",
    "顺捷丰达",
    "德国雄鹰速递",
    "八达通",
    "比利时(BELGIUM POST)",
    "保加利亚（BULGARIAN POSTS）",
    "CCES/国通快递",
    "CNAIR",
    "中外运",
    "FOX国际快递",
    "GTT EXPRESS快递",
    "海联快递",
    "大马鹿",
    "木春货运",
    "TRACK-PARCEL",
    "易欧洲国际物流",
    "安达信",
    "德方物流",
    "大道物流",
    "中欧国际物流",
    "华企快运",
    "急先达",
    "快8速运",
    "马来西亚大包、EMS（MALAYSIA POST(PARCEL,EMS)）",
    "巴基斯坦(PAKISTAN POST)",
    "赛澳递",
    "泰进物流",
    "祥龙运通物流",
    "银捷速递",
    "易通达",
    "众派速递",
    "卓实快运",
    "法国大包、EMS-英文(CHRONOPOST FRANCE)",
    "C&C国际速递",
    "达方物流",
    "环国运物流",
    "云邮跨境快递",
    "华美快递",
    "柬埔寨中通",
    "民邦速递",
    "PCA EXPRESS",
    "日昱物流",
    "RPX",
    "一起送",
    "明大快递",
    "捷记方舟",
    "店通快递",
    "飞邦快递",
    "FEDROAD 联邦转运",
    "花瓣转运",
    "飞力士物流",
    "法翔速运",
    "极光转运",
    "番薯国际货运",
    "NOVA POSHTA",
    "秘鲁(SERPOST)",
    "7E速递",
    "全川物流",
    "阳光快递",
    "王牌快递",
    "乌兹别克斯坦(POST OF UZBEKISTAN)",
    "香港伟豪国际物流",
    "美国云达",
    "忠信达",
    "河南次晨达",
    "邦通国际",
    "DPD GERMANY",
    "FASTWAY IRELAND",
    "FQ狂派速递",
    "GHT物流",
    "飞鹰物流",
    "骏丰国际速递",
    "KCS",
    "鲁通快运",
    "澳洲迈速快递",
    "MORELINK",
    "葡萄牙（PORTUGAL CTT）",
    "坦桑尼亚（TANZANIA POSTS CORPORATION）",
    "巴布亚新几内亚(PNG POST)",
    "全际通",
    "申必达",
    "红马甲物流",
    "51跨境通",
    "远航国际快运",
    "元智捷诚",
    "新干线快递",
    "中联速递",
    "宝通快递",
    "CANPAR",
    "华欣物流",
    "中骅物流",
    "城晓国际快递",
    "CE易欧通国际速递",
    "E跨通",
    "英国(大包,EMS)",
    "易达国际速递",
    "格鲁吉亚(GEORGIAN POS）",
    "国送快运",
    "海外环球",
    "红远物流",
    "JDIEX",
    "拉脱维亚(LATVIJAS PASTS)",
    "北极星快运",
    "全通快运",
    "三盛快递",
    "首达速运",
    "顺通快递",
    "TOLL PRIORITY(TOLL ONLINE)",
    "亚马逊中国",
    "宜送物流",
    "航空快递",
    "成达国际速递",
    "城际快递",
    "重庆星程快递",
    "东风快递",
    "天翔东捷运",
    "DPD UK",
    "澳州顺风快递",
    "GLS",
    "万通快递",
    "GTS快递",
    "海盟速递",
    "HI淘易快递",
    "匈牙利（MAGYAR POSTA）",
    "印度(INDIA POST)",
    "骏达快递",
    "晋越快递",
    "凯信达",
    "隆浪快递",
    "迈隆递运",
    "MRW",
    "OCA ARGENTINA",
    "顺邦国际物流",
    "顺士达速运",
    "中外运空运",
    "三象速递",
    "通和天下",
    "乌干达(POSTA UGANDA)",
    "鹰运国际速递",
    "新元快递",
    "YDH",
    "宇航通物流",
    "雅澳物流",
    "一运全成物流",
    "阿富汗(AFGHAN POST)",
    "AMAZON-国内订单",
    "澳速物流",
    "APLUS物流",
    "澳货通",
    "澳新物流",
    "报通快递",
    "城铁速递",
    "长宇物流",
    "同舟行物流",
    "嘉荣物流",
    "华中快递",
    "达速物流",
    "DHL HK",
    "递四方美国",
    "东红物流",
    "东西E全运",
    "龙象国际物流",
    "E直运",
    "易联通达",
    "希腊EMS（ELTA COURIER）",
    "EU-EXPRESS",
    "易邮国际",
    "FEDEX-英国件",
    "飞狐快递",
    "芬兰(ITELLA POSTI OY)",
    "安的快递",
    "环创物流",
    "好又快物流",
    "河南全速通",
    "居家通",
    "红背心",
    "高铁速递",
    "华达快运",
    "环东物流",
    "汇森速运",
    "冰岛(ICELAND POST)",
    "以色列(ISRAEL POST)",
    "ITALY SDA",
    "驿扬国际速运",
    "劲通快递",
    "约旦(JORDAN POST)",
    "哈萨克斯坦(KAZPOST)",
    "快服务",
    "蓝镖快递",
    "丽狮物流",
    "小熊物流",
    "长风物流",
    "恒通快递",
    "美泰物流",
    "银河物流",
    "昂威物流",
    "波音速递",
    "英国邮政大包EMS",
    "配思货运",
    "ANTS EXPRESS",
    "QUANTIUM",
    "全之鑫物流",
    "荣庆物流",
    "罗马尼亚（POSTA ROMANIAN）",
    "日日顺快线",
    "SAFEXPRESS",
    "速呈",
    "塞尔维亚(PE POST OF SERBIA)",
    "圣飞捷快递",
    "上海快通",
    "盛通快递",
    "SHL畅灵国际物流",
    "SIODEMKA",
    "嗖一下同城快递",
    "星运快递",
    "特急便物流",
    "穗佳物流",
    "速配欧翼",
    "瑞士邮政",
    "深圳邮政",
    "TD CARGO",
    "天联快运",
    "海龟国际快递",
    "乌克兰小包、大包(UKRPOSHTA)",
    "渥途国际速运",
    "伍圆速递",
    "西安城联速递",
    "湘达物流",
    "鑫世锐达",
    "鑫远东速运",
    "也门(YEMEN POST)",
    "艺凡快递",
    "YODEL",
    "永邦国际物流",
    "远为快递",
    "三三国际物流",
    "珠峰速运",
    "安达易国际速递",
    "AFL",
    "全程快递",
    "卡邦配送",
    "阿尔巴尼亚(POSTA SHQIPATRE)",
    "无忧物流",
    "AMAZON-国际订单",
    "APGECOMMERCE",
    "美国汉邦快递",
    "艾瑞斯远",
    "阿鲁巴[荷兰]（POST ARUBA）",
    "奥地利(AUSTRIAN POST)",
    "AUV国际快递",
    "阿塞拜疆EMS(EMS AZEREXPRESSPOST)",
    "巴林(BAHRAIN POST)",
    "孟加拉国(EMS)",
    "BCWELT",
    "伯利兹(BELIZE POSTAL)",
    "白俄罗斯(BELPOCHTA)",
    "笨鸟国际",
    "青云物流",
    "鑫锐达",
    "BLUEDART",
    "标杆物流",
    "波黑(JP BH POSTA)",
    "玻利维亚",
    "BORDERGURU",
    "堡昕德速递",
    "博茨瓦纳",
    "速方(SUFAST)",
    "巴西(BRAZIL POST/CORREIOS)",
    "文莱(BRUNEI POSTAL)",
    "新喀里多尼亚[法国](NEW CALEDONIA)",
    "柬埔寨(CAMBODIA POST)",
    "到了港",
    "CAMPBELL’S EXPRESS",
    "能装能送",
    "卢森堡航空",
    "钏博物流",
    "CDEK",
    "捷克（?ESKÁ PO?TA）",
    "CEVA LOGISTIC",
    "银雁专送",
    "昌宇国际",
    "智利(CORREOS CHILE)",
    "中邮电商",
    "CHRONOPOST PORTUGAL",
    "城市映急",
    "CITYSPRINT",
    "大韩通运",
    "CL日中速运",
    "中欧物流",
    "CNE",
    "CNUP 中联邮",
    "哥伦比亚(4-72 LA RED POSTAL DE COLOMBIA)",
    "莫桑比克（CORREIOS DE MOÇAMBIQUE）",
    "乌拉圭（CORREO URUGUAYO）",
    "阿根廷(CORREO ARGENTINA)",
    "哥斯达黎加(CORREOS DE COSTA RICA)",
    "环旅快运",
    "新时速物流",
    "塞浦路斯(CYPRUS POST)",
    "云南诚中物流",
    "DCS",
    "德中快递",
    "DELTEC COURIER",
    "澳行快递",
    "DHL-荷兰（DHL NETHERLANDS）",
    "DHL-波兰（DHL POLAND）",
    "递五方云仓",
    "云南滇驿物流",
    "递达速运",
    "叮咚澳洲转运",
    "叮咚快递",
    "DIRECT LINK",
    "东瀚物流",
    "DPD POLAND",
    "DTDC INDIA",
    "DUODAO56",
    "东方航空物流",
    "EC-FIRSTCLASS",
    "ECMS EXPRESS",
    "厄瓜多尔(CORREOS DEL ECUADOR)",
    "易达快运",
    "埃及（EGYPT POST）",
    "艾菲尔国际速递",
    "希腊包裹（ELTA HELLENIC POST）",
    "阿联酋(EMIRATES POST)",
    "波兰小包(POCZTA POLSKA)",
    "南非EMS",
    "乌克兰EMS(EMS UKRAINE)",
    "乌克兰EMS-中文(EMS UKRAINE)",
    "联众国际",
    "ESTAFETA",
    "ESTES",
    "埃塞俄比亚(ETHIOPIAN POSTAL)",
    "德国 EUC POST",
    "败欧洲",
    "EUROPEANECOM",
    "优莎速运",
    "澳洲新干线快递",
    "易转运",
    "颿达国际快递-英文",
    "颿达国际快递",
    "正途供应链",
    "FEDEX-英国件（FEDEX UK)",
    "飞快达",
    "凤凰快递",
    "斐济(FIJI POST)",
    "全速快递",
    "高铁快运",
    "GATI-中文",
    "GATI-英文",
    "GATI-KWE",
    "广东诚通物流",
    "全网物流",
    "容智快运",
    "新鹏快递",
    "GE2D跨境物流",
    "直布罗陀[英国]( ROYAL GIBRALTAR POST)",
    "冠捷物流 ",
    "英脉物流",
    "格陵兰[丹麦]（TELE GREENLAND A/S）",
    "潍鸿",
    "哥士传奇速递",
    "GT国际快运",
    "广通速递",
    "广东通路",
    "冠庭国际物流",
    "宏观国际快递",
    "贵州星程快递",
    "海红FOR买卖宝",
    "海星桥快递",
    "汉邦国际速递",
    "翰丰快递",
    "航宇快递",
    "开心快递",
    "亚美尼亚(HAYPOST-ARMENIAN POSTAL)",
    "黑猫速运",
    "恒瑞物流",
    "猴急送",
    "互联快运",
    "共联配",
    "顺时达物流",
    "中强物流",
    "宏捷国际物流",
    "宏品物流",
    "环球通达 ",
    "卓烨快递",
    "克罗地亚（HRVATSKA POSTA）",
    "海硕高铁速递",
    "华通快运",
    "华通务达物流",
    "华夏货运",
    "汇强快递",
    "兰州伙伴物流",
    "户通物流",
    "鸿远物流",
    "上海昊宏国际货物",
    "华航快递",
    "大达物流",
    "IEXPRESS",
    "LOGEN路坚",
    "ILYANG",
    "艾姆勒",
    "印度尼西亚EMS(POS INDONESIA-EMS)",
    "多米尼加（INPOSDOM – INSTITUTO POSTAL DOMINICANO）",
    "INTERLINK EXPRESS",
    "UPS I-PARCEL",
    "伊朗（IRAN POST）",
    "急递",
    "泽西岛",
    "澳速通国际速递",
    "佳家通货运",
    "锦程物流",
    "九宫物流",
    "久易快递",
    "佳捷翔物流",
    "骏绅物流",
    "聚物物流",
    "聚中大",
    "考拉国际速递",
    "跨境直邮通",
    "韩国邮政韩文",
    "淘韩国际快递",
    "快达物流",
    "快淘快递",
    "四川快优达速递",
    "吉尔吉斯斯坦(KYRGYZ POST)",
    "蓝弧快递",
    "老挝(LAO EXPRESS) ",
    "塞内加尔",
    "林安物流",
    "立白宝凯物流",
    "林道国际快递-英文",
    "乐递供应链",
    "云豹国际货运",
    "美联快递",
    "LAZADA",
    "联运快递",
    "黎巴嫩(LIBAN POST)",
    "LINEX",
    "立陶宛（LIETUVOS PA?TAS）",
    "良藤国际速递",
    "華信物流WTO",
    "6LS EXPRESS",
    "乐天速递",
    "联通快递",
    "论道国际物流",
    "卢森堡(LUXEMBOURG POST)",
    "LWE",
    "马其顿(MACEDONIAN POST)",
    "麦力快递",
    "马尔代夫(MALDIVES POST)",
    "马耳他（MALTA POST）",
    "芒果速递",
    "今枫国际快运",
    "毛里求斯(MAURITIUS POST)",
    "美邦国际快递",
    "美达快递",
    "墨西哥（CORREOS DE MEXICO）",
    "MEXICO SENDA EXPRESS",
    "美龙快递",
    "摩尔多瓦(POSTA MOLDOVEI)",
    "蒙古国(MONGOL POST) ",
    "黑山(POSTA CRNE GORE)",
    "摩洛哥 ( MOROCCO POST )",
    "MEXICO MULTIPACK",
    "中俄速通（淼信）",
    "MYHERMES",
    "新亚物流",
    "纳米比亚(NAMPOST)",
    "红马速递",
    "尼泊尔（NEPAL POSTAL SERVICES）",
    "尼日利亚(NIGERIAN POSTAL)",
    "浩博物流",
    "NLE",
    "华赫物流",
    "诺尔国际物流",
    "偌亚奥国际快递",
    "阿曼(OMAN POST)",
    "爱沙尼亚(EESTI POST)",
    "OPEK",
    "巴拉圭(CORREO PARAGUAYO)",
    "诚一物流",
    "全球速递",
    "派尔快递",
    "陪行物流",
    "鹏程快递",
    "菲律宾（PHILIPPINE POSTAL）",
    "品速心达快递",
    "品信快递",
    "先锋国际快递",
    "PORTUGAL SEUR",
    "POSTELBE",
    "POSTNORD(POSTEN AB)",
    "挪威（POSTEN NORGE）",
    "土耳其",
    "PUROLATOR",
    "急顺通",
    "雪域快递",
    "千顺快递",
    "全信通快递",
    "RED EXPRESS",
    "叙利亚(SYRIAN POST)",
    "睿和泰速运",
    "日日通国际",
    "卢旺达(RWANDA I-POSITA)",
    "S2C",
    "萨摩亚(SAMOA POST)",
    "沙特阿拉伯(SAUDI POST)",
    "中加国际快递",
    "四川星程快递",
    "SELEKTVRACHT",
    "INTERNATIONAL SEUR",
    "澳丰速递",
    "十方通物流",
    "曹操到",
    "衫达快运",
    "上海无疆FOR买卖宝",
    "尚途国际货运",
    "捎客物流",
    "商海德物流",
    "神马快递",
    "苏豪快递",
    "世运快递",
    "WISH邮",
    "四海快递",
    "四海捷运",
    "中外运速递-中文",
    "易普递",
    "SKYNET",
    "SKYNET MALAYSIA",
    "SKYNETWORLDWIDE",
    "荷兰SKY POST",
    "斯洛伐克(SLOVENSKÁ POSTA)",
    "斯里兰卡(SRI LANKA POST)",
    "南非（SOUTH AFRICAN POST OFFICE）",
    "行必达",
    "首通快运",
    "星速递",
    "速豹",
    "速呈宅配",
    "苏丹（SUDAPOST）",
    "郑州速捷",
    "速品快递",
    "深圳DPEX",
    "天美快递",
    "坦桑尼亚(TANZANIA POSTS)",
    "TCI XPS",
    "加拿大雷霆快递",
    "天翔快递",
    "天纵物流",
    "万家通快递",
    "株式会社T.M.G",
    "TNT ITALY",
    "TNT POST",
    "TNY物流",
    "通达兴物流",
    "顶世国际物流",
    "突尼斯EMS(RAPID-POSTE)",
    "UEX国际物流",
    "邮鸽速运",
    "乌克兰小包、大包(UKRPOST)",
    "优联吉运",
    "UPS FREIGHT",
    "UPS MAIL INNOVATIONS",
    "华夏国际速递",
    "UTAO优到",
    "瓦努阿图(VANUATU POST)",
    "越中国际物流",
    "越南小包(VIETNAM POSTS)",
    "万博快递",
    "宁夏万家通",
    "万达美",
    "文捷航空",
    "万邑通",
    "凡仕特物流",
    "沃埃家",
    "WTD海外通",
    "万运国际快递",
    "微转运",
    "西安胜峰",
    "国晶物流",
    "翔腾物流",
    "小C海淘",
    "西安喜来快递",
    "新宁物流",
    "西邮寄",
    "鑫通宝物流",
    "一辉物流",
    "YCG物流",
    "驿递汇速递",
    "易航物流",
    "亿领速运",
    "一柒国际物流",
    "亿顺航",
    "宜送",
    "易邮速运",
    "武汉优进汇",
    "洋口岸",
    "友家速递",
    "邮来速递",
    "壹品速递",
    "运通快运",
    "远盾物流",
    "粤中国际货运代理（上海）有限公司",
    "御风速运",
    "西安运逸快递",
    "众辉达物流",
    "志腾物流",
    "众邮快递"
  ]
  
  
    const data2 = [
      "中通快递",
      "韵达快递",
      "圆通速递",
      "百世快递",
      "邮政快递包裹",
      "申通快递",
      "顺丰速运",
      "京东物流",
      "天天快递",
      "EMS",
      "邮政标准快递",
      "宅急送",
      "德邦",
      "德邦快递",
      "中通快运",
      "优速快递",
      "韵达快运",
      "百世快运",
      "安能快运",
      "圆通快运",
      "万象物流",
      "DHL-中国件",
      "苏宁物流",
      "极兔速递",
      "丹鸟",
      "EMS-国际件",
      "YUN TRACK",
      "EWE全球快递",
      "国际包裹",
      "加拿大(CANADA POST)",
      "UPS-全球件",
      "圆通国际",
      "FEDEX-国际件",
      "速尔快递",
      "日日顺物流",
      "同城快寄",
      "跨越速运",
      "USPS",
      "TNT",
      "澳邮中国快运",
      "龙邦速递",
      "DHL-全球件",
      "卓志速运",
      "中邮物流",
      "京广速递",
      "燕文物流",
      "壹米滴答",
      "九曳供应链",
      "邦泰快运",
      "特急送",
      "联合快递",
      "转运四方",
      "中通国际",
      "安得物流",
      "快捷速递",
      "程光快递",
      "联邦快递"
    ]
  
  
  export default{
	  data,data2
  }